import dynamicRoute from 'root/utils/dynamicRoute';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: dynamicRoute({
      component: () => import('./routes/LoginPage/index')
    })
  },
  {
    path: '/resetPwd',
    name: 'resetPwd',
    component: dynamicRoute({
      component: () => import('./routes/ForgetPwd/index')
    })
  }
];

export default routes;
